import React from 'react';
import Warning from 'Common/Components/Warning';
import { Wrapper, ModalWrapper } from 'Common/Components/ConfirmNavigationModal/styled';
import { StyledMessage } from 'Screens/Contextualization/ManageEditCreate/components/ManualCreationModal/components/CreationWarning/styled';
import { useDispatch, useSelector } from 'react-redux';
import useShortcut from 'Hooks/useShortcut';
import useShortcutScope from 'Hooks/useShortcutScope';
import { selectErrorMessageCreateService, selectErrorTitleCreateService } from 'store/Services/selectors';
import { setCreateServiceError } from 'store/Services/actions';
import { Asterisk } from 'Common/Components/CreationWarning/styled';

const Message = ({ errorTitle, errorMessage }) => {
  if (errorTitle === 'Create Service') return <StyledMessage>{ errorMessage } ( <Asterisk /> )</StyledMessage>;
  return <StyledMessage>{ errorMessage }</StyledMessage>;
};

const CreationWarning = () => {
  const dispatch = useDispatch();
  const errorTitle = useSelector(selectErrorTitleCreateService);
  const errorMessage = useSelector(selectErrorMessageCreateService);

  const scope = useShortcutScope('creation-warning');
  useShortcut('Escape', () => dispatch(setCreateServiceError(false, '', '')), { scope });

  return (
    <Wrapper>
      <ModalWrapper>
        <Warning
          title={ errorTitle }
          children={ <Message errorTitle={ errorTitle } errorMessage={ errorMessage } /> }
          onClose={ () => dispatch(setCreateServiceError(false, '', '')) }
        />
      </ModalWrapper>
    </Wrapper>
  );
};

export default CreationWarning;
